import {Observable, of} from 'rxjs';
import {PreloadingStrategy, Route} from '@angular/router';
import {Injectable} from '@angular/core';

@Injectable()
export class SelectivePreloadingStrategy implements PreloadingStrategy {

  constructor() {
  }

  preload(route: Route, load: () => Observable<any>): Observable<any> {

    return route.data && route.data.preload ? load() : of(false);
  }
}
